import {v4 as uuidv4} from "uuid";

export type Schedule = {
    ScheduleId: string,
    EventId: string,
    RoomId: string,
    TimeSlotId: string,
    SessionId: string,
}

export function newSchedule(): Schedule {
    return {
        ScheduleId: uuidv4(),
        EventId: "",
        RoomId: "",
        TimeSlotId: "",
        SessionId: "",
    };
}

export function newScheduleArray(): Schedule[] {
    return [];
}